import { createSelector } from '@reduxjs/toolkit';
import { FDealType, FOfferType } from '../../../../packages/JsonQuery';
import { selectDealType, selectIsEncumbranceRealty, selectOfferType } from 'shared/selectors/jsonQuery';

export const selectEncumbranceRealtyValue = createSelector(
  [selectDealType, selectOfferType, selectIsEncumbranceRealty],
  (dealType, offerType, isEncumbranceRealty) => {
    const isSale = dealType === FDealType.Sale;
    const isFlat = (offerType & FOfferType.Flat) !== 0;

    if (!isSale || !isFlat) {
      return null;
    }

    return isEncumbranceRealty;
  },
);
